export default {
  title: 'Rekentool servicekosten omzet',
  description: 'Schat wat de servicekosten maandelijks opleveren. Cijfers worden bijgewerkt tijdens het typen.',
  authoritative:
    'Het percentage en maximumtarief hieronder zijn de instellingen die worden toegepast. Gemiddelde orderwaarde en maandelijkse GMV zijn slechts schattingen.',
  off_notice:
    'De servicekosten staan uit bij dit restaurant, dus er wordt nog niets mee verdiend. Sla een bedrag hoger dan 0 op om ze in te schakelen.',
  fields: {
    recommended: 'Aanbevolen: {{value}}',
    aov: {
      label: 'Gemiddelde orderwaarde',
      help: 'Gebruikelijke bestelgrootte op uw online bestelsysteem.',
      placeholder: 'bijv. 32,50',
    },
    percentage: {
      label: 'Percentage servicekosten',
      help: 'Tussen {{min}}% en {{max}}%.',
    },
    max_amount: {
      label: 'Maximale kosten per bestelling',
      help: '{{max}} is het platformmaximum.',
      below_min: 'De maximale vergoeding moet minstens {{min}} zijn.',
    },
    monthly_gmv: {
      label: 'Maandelijkse GMV',
      help: 'Totale orderwaarde verwerkt per maand.',
      placeholder: 'bijv. 85000',
    },
  },
  outputs: {
    partner_revenue: 'Uw geschatte maandelijkse omzet',
    approximate: 'Geschat cijfer op basis van bovenstaande waarden — werkelijke omzet kan afwijken.',
    estimate_inputs: 'Gebaseerd op uw geschatte orderwaarde en GMV — werkelijke omzet kan afwijken.',
    share: 'Dit is uw {{share}}% aandeel in de totale geïnde servicekosten.',
    total_collected: 'Totale servicekosten geïnd van gasten bij het afrekenen',
    total_collected_note: '— betaald door gasten, geen extra omzet bovenop bovenstaand cijfer.',
    effective_rate: 'Effectief kostenpercentage over alle bestellingen',
  },
};
